import { useState } from 'react';
import { createPortal } from 'react-dom';
import RenewFilterModal from './RenewFilterModal';

interface UseRenewFilterModalProps {
  onRenew?: () => void;
  onRemove?: () => void;
}

export const useRenewFilterModal = ({ onRenew, onRemove }: UseRenewFilterModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const handleRenew = () => {
    onRenew?.();
    close();
  };

  const handleRemove = () => {
    onRemove?.();
    close();
  };

  const Modal = () => {
    if (!isOpen) return null;

    return createPortal(
      <div
        className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 pointer-events-none"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <div className="pointer-events-auto">
          <RenewFilterModal onRenew={handleRenew} onRemove={handleRemove} />
        </div>
      </div>,
      document.body,
    );
  };

  return {
    open,
    close,
    Modal,
  };
};
